/* RapidPlas purchase mode — Golden Panda / SF035
   cart  : native Add to Cart only
   quote : native button hidden, Add to Quote takes its place next to quantity
   both  : native Add to Cart row + Add to Quote beneath
   "Add to Quote" adds the current variant + quantity to the cart with a hidden
   _Quote flag; the cart page then offers Request a Quote instead of checkout.
   The product form is Preact-rendered, so the swap is re-applied on DOM changes. */
(function () {
  'use strict';

  function nativeAddButton(root) {
    var form = root.querySelector('product-form') || root;
    var candidates = form.querySelectorAll('button, [type="submit"]');
    for (var i = 0; i < candidates.length; i++) {
      var b = candidates[i];
      if (b.hasAttribute('data-rp-add-quote')) continue;
      var t = (b.textContent || '').trim().toLowerCase();
      if (b.getAttribute('type') === 'submit' || b.getAttribute('name') === 'add' || t === 'add to cart' || t.indexOf('add to cart') !== -1) {
        return b;
      }
    }
    return null;
  }

  function applyMode(root) {
    var mode = root.getAttribute('data-rp-mode');
    var ours = root.querySelector('[data-rp-add-quote]');
    if (mode !== 'quote' || !ours) return;

    var native = nativeAddButton(root);
    if (!native) return;

    native.style.setProperty('display', 'none', 'important');
    native.setAttribute('aria-hidden', 'true');

    // Put our button where the native one sits, wearing the same classes so it
    // fills the row beside the quantity picker exactly like Add to Cart did.
    if (ours.parentNode !== native.parentNode) {
      ours.className = native.className + ' rp-purchase__quote-btn rp-purchase__quote-btn--inline';
      native.parentNode.insertBefore(ours, native.nextSibling);
    }
  }

  // SKU -> variant id, emitted by rp-purchase-buttons.liquid. The theme renders
  // no input[name="id"] and does not keep ?variant= in sync, so the only signal
  // that reliably tracks the selected size is the variant's Code line on the
  // page. Same approach as the delivery locator, resolving to an id here.
  var skuToVariant = null;
  function loadSkuMap(btn) {
    if (skuToVariant !== null) return skuToVariant;
    skuToVariant = {};
    try {
      var root = btn ? btn.closest('.rp-purchase') : null;
      var tag = (root || document).querySelector('[data-rp-variant-sku-ids]');
      var raw = tag ? JSON.parse(tag.textContent) : {};
      for (var k in raw) if (k && raw[k]) skuToVariant[k.trim().toUpperCase()] = String(raw[k]);
    } catch (e) { /* leave empty */ }
    return skuToVariant;
  }

  function variantFromSku(btn) {
    var map = loadSkuMap(btn);
    var els = document.querySelectorAll('span, div, p, small, strong, b, em, li, td, dd');
    var found = null;
    for (var j = 0; j < els.length; j++) {
      var el = els[j];
      if (el.offsetParent === null) continue;
      // Own text nodes only: the Code line is <p><span>Code</span> SKU</p>.
      var own = '';
      for (var c = 0; c < el.childNodes.length; c++) {
        if (el.childNodes[c].nodeType === 3) own += el.childNodes[c].nodeValue;
      }
      var t = own.trim().toUpperCase().replace(/^CODE\s+/, '');
      if (t && map[t]) found = map[t];
    }
    return found;
  }

  // Order: the Code line -> locator (when present) -> the form's hidden input
  // -> ?variant= -> the variant Liquid pre-selected on the button.
  function currentVariantId(btn) {
    var fromSku = variantFromSku(btn);
    if (fromSku) return fromSku;
    var loc = document.querySelector('[data-rp-locator]');
    if (loc && loc.__rpLocator && loc.__rpLocator.currentVariantId) {
      var v = loc.__rpLocator.currentVariantId();
      if (v) return v;
    }
    var input = document.querySelector('product-form input[name="id"], product-form select[name="id"], input[name="id"]');
    if (input && input.value) return input.value;
    var url = new URL(window.location.href);
    var fromUrl = url.searchParams.get('variant');
    if (fromUrl) return fromUrl;
    var fallback = btn && btn.getAttribute('data-default-variant');
    return fallback || null;
  }

  // A quantity picker's options are consecutive integers starting at 1. Product
  // option selects can also be all-numeric (Pro Tub Troughs has Capacity: 1200),
  // so "all numeric" alone matched the wrong dropdown and priced 1200 items.
  function isQuantitySelect(s) {
    if (!s.options || !s.options.length) return false;
    for (var i = 0; i < s.options.length; i++) {
      var t = (s.options[i].textContent || '').trim();
      if (!/^\d+$/.test(t)) return false;
      if (parseInt(t, 10) !== i + 1) return false;
    }
    return true;
  }

  // The shopper's own interaction is the most reliable source: whichever
  // quantity select they actually change, we record it. This sidesteps every
  // guess about which duplicate is visible or which comes first in the DOM —
  // the theme renders the product column once per breakpoint.
  var lastUserQty = 0;
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || el.tagName !== 'SELECT' || !isQuantitySelect(el)) return;
    var q = parseInt(el.value, 10);
    if (q > 0) lastUserQty = q;
  }, true);

  // Last resort, and the one that matters at desktop width: the theme renders
  // the quantity as a custom widget with no <select> at all, so there is
  // nothing to read by element type. Find the visible Add to Cart / Add to
  // Quote button and take the bare number displayed beside it in the same row.
  function qtyFromWidget() {
    var btn = null;
    var bs = document.querySelectorAll('button, [type="submit"]');
    for (var i = 0; i < bs.length; i++) {
      if (bs[i].offsetParent === null) continue;
      var t = (bs[i].textContent || '').trim().toLowerCase();
      // Out-of-stock products still show a quantity picker, and the button text
      // changes, so match those labels too or the widget is never found.
      if (t === 'add to cart' || t === 'add to quote' || t === 'out of stock' ||
          t === 'sold out' || t === 'unavailable') { btn = bs[i]; break; }
    }
    if (!btn) return 0;

    var node = btn;
    for (var up = 0; up < 4 && node; up++) {
      node = node.parentNode;
      if (!node || !node.querySelectorAll) break;
      var kids = node.querySelectorAll('*');
      for (var k = 0; k < kids.length; k++) {
        var el = kids[k];
        if (el === btn || btn.contains(el) || el.contains(btn)) continue;
        if (el.children.length) continue;          // leaf nodes only
        if (el.offsetParent === null) continue;    // must be on screen
        var txt = (el.textContent || '').trim();
        if (/^\d{1,3}$/.test(txt)) {
          var q = parseInt(txt, 10);
          if (q > 0) return q;
        }
      }
    }
    return 0;
  }

  // Visible wins — the product column is rendered twice (mobile and desktop), so
  // the first quantity select in DOM order can be the hidden one, still at 1.
  function pickQty(nodes) {
    var hidden = 0;
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.tagName === 'SELECT' && !isQuantitySelect(el)) continue;
      var q = parseInt(el.value, 10);
      if (!(q > 0)) continue;
      if (el.offsetParent === null) { if (!hidden) hidden = q; continue; }
      return q;
    }
    return hidden;
  }

  // Same independence for quantity: match on name first, then a select shaped
  // like a quantity picker, then the custom widget.
  function currentQty() {
    var loc = document.querySelector('[data-rp-locator]');
    if (loc && loc.__rpLocator && loc.__rpLocator.currentQty) return loc.__rpLocator.currentQty();

    if (lastUserQty > 0) return lastUserQty;
    var named = pickQty(document.querySelectorAll('[name="quantity"], [data-quantity], [data-quantity-input]'));
    if (named > 0) return named;
    var fromSelect = pickQty(document.querySelectorAll('select'));
    if (fromSelect > 0) return fromSelect;
    return qtyFromWidget() || 1;
  }

  function addToQuote(btn) {
    var id = currentVariantId(btn);
    if (!id) { alert('Please choose an option first.'); return; }
    var qty = currentQty();
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = 'Adding\u2026';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: qty, properties: { _Quote: 'Yes' } }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      // Stay on the product page (Roy, 22 Sep 2026). rp-cart-added shows the
      // confirmation and refreshes the header count, so the shopper can keep
      // adding items to a quote without being pulled to the cart each time.
      btn.disabled = false;
      btn.textContent = label;
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = label;
      alert('Sorry, we couldn\u2019t add that to your quote. Please try again or contact our sales team.');
    });
  }

  function init() {
    document.querySelectorAll('.rp-purchase').forEach(function (root) {
      var btn = root.querySelector('[data-rp-add-quote]');
      if (btn && !btn.__rpBound) {
        btn.__rpBound = true;
        btn.addEventListener('click', function () { addToQuote(btn); });
      }
      applyMode(root);
      if (!root.__rpObserved && 'MutationObserver' in window) {
        root.__rpObserved = true;
        var pending = false;
        new MutationObserver(function () {
          if (pending) return;
          pending = true;
          window.requestAnimationFrame(function () { pending = false; applyMode(root); });
        }).observe(root, { childList: true, subtree: true });
      }
      [300, 1000, 2500].forEach(function (ms) { setTimeout(function () { applyMode(root); }, ms); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
